import { Injectable } from '@angular/core';
import { AdyenEnvironments, AdyenSession } from '@app/shared/models/shop-offers.model';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class AdyenService {
  private adyenPromise?: Promise<typeof import('@adyen/adyen-web/auto')>;
  // eslint-disable-next-line
  private checkoutInstance: any;
  // eslint-disable-next-line
  private checkoutReadyPromise?: Promise<void>;

  // eslint-disable-next-line
  onPaymentCompleted?: (result: any, component: any) => void;
  // eslint-disable-next-line
  onError?: (error: any) => void;

  getAdyen() {
    if (!this.adyenPromise) {
      this.adyenPromise = import('@adyen/adyen-web/auto');
    }

    return this.adyenPromise;
  }

  createCheckoutInstance(session: AdyenSession): void {
    this.checkoutReadyPromise = (async () => {
      const adyen = await this.getAdyen();

      this.checkoutInstance = await adyen.AdyenCheckout({
        environment: environment.adyenConfig.env as AdyenEnvironments,
        clientKey: environment.adyenConfig.clientKey,
        analytics: { enabled: false },
        session,

        onPaymentCompleted: async (result, component) => {
          this.onPaymentCompleted?.(result, component);
        },

        onPaymentFailed: async (result, component) => {
          this.onPaymentCompleted?.(result, component);
        },

        onError: (error) => {
          this.onError?.(error);
        },
      });
    })();
  }

  // eslint-disable-next-line
  async waitForCheckout(): Promise<any> {
    await this.checkoutReadyPromise;
    return this.checkoutInstance;
  }

  getCheckout() {
    return this.checkoutInstance;
  }

  clear() {
    this.checkoutInstance = null;
  }
}
